import { Chip, Stack } from "@mui/joy";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

/** Чипы пройденных тестов в карточке. props: quizzes ([{code,title,image}]), max */
export default function PassedQuizzesChips({ quizzes, max = 2 }) {
  if (!quizzes || quizzes.length === 0) return null;
  const shown = quizzes.slice(0, max);
  const rest = quizzes.length - shown.length;
  return (
    <Stack direction="row" flexWrap="wrap" spacing={0.5} sx={{ mt: 1 }}>
      {shown.map((q) => (
        <Chip
          key={q.code}
          size="sm"
          variant="soft"
          color="success"
          startDecorator={<CheckCircleRoundedIcon />}
        >
          {q.title}
        </Chip>
      ))}
      {rest > 0 && (
        <Chip size="sm" variant="soft" color="neutral">
          +{rest}
        </Chip>
      )}
    </Stack>
  );
}